import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo e Descrição - CORRIGIDO */}
          <div>
            <img 
              src="/logo.png"  // ← Brasão local [file:95]
              alt="Pequeninos do Jockey" 
              className="h-12 mb-4 hover:scale-105 transition-transform"
              loading="lazy"
            />
            <p className="text-gray-400 text-sm">
              Transformando crianças em grandes seres humanos há mais de 45 anos.
            </p>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Links Rápidos</h3>
            <ul className="space-y-2">
              <li><Link to="/athletes" className="text-gray-400 hover:text-red-400 transition">Ex-Atletas</Link></li>
              <li><Link to="/championships" className="text-gray-400 hover:text-red-400 transition">Campeonatos</Link></li>
              <li><Link to="/categories" className="text-gray-400 hover:text-red-400 transition">Categorias</Link></li>
              <li><Link to="/enrollment" className="text-gray-400 hover:text-red-400 transition">Inscrição</Link></li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-center text-gray-400 hover:text-red-400 transition">
                <Phone size={18} className="mr-3 text-red-500 flex-shrink-0" />
                <span>(11) 3751-0670</span>
              </li>
              <li className="flex items-center text-gray-400 hover:text-red-400 transition">
                <Mail size={18} className="mr-3 text-red-500 flex-shrink-0" />
                <a href="mailto:pequeninos@pequeninos.com.br" className="hover:underline">
                  pequeninos@pequeninos.com.br
                </a>
              </li>
              <li className="flex items-start text-gray-400 hover:text-red-400 transition">
                <MapPin size={18} className="mr-3 text-red-500 flex-shrink-0 mt-0.5" />
                <span>Unidade Colombo<br /><span className="text-sm">São Paulo, SP</span></span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} Pequeninos do Jockey. 
            <span className="ml-2 text-xs">Todos os direitos reservados.</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;